class Variants extends HTMLElement {
    constructor() {
      super();
      let p = document.querySelector('[id="ProductJSON"]');
      this.product = new window.Shopify.Product(JSON.parse(p.textContent));
      this.allSelectors = this.querySelector('variant-radios');
    }
  
    connectedCallback() {
      this.hideInvalidOptions();
      this.allSelectors.addEventListener('change', () => {
          this.variantChange();
      });
  
    }
    variantChange(){

        var variant = this.product.getVariant(this.selectedValues());
        if(!variant){
           //PRESELECT  FIRST
          const selected = this.selectedValues();
          if(selected.length == 3){
             let items = [selected[0], selected[1]];
  
             const newVariant = this.product.variants.find((v) => {
               if(items.every(elem => v.options.includes(elem))){
                 return v
               }else{
                  return false
              }
  
             })
  
            if(newVariant){
              newVariant.options.map((option) => {
                let input = this.querySelector(`input[value='${option}']`);
                if(input){
                    input.click() 
                }
              })
            }else{
              const newVariant = this.product.variants.find((v) => {
                if(v.options.includes(selected[0])){
                    return v
                }else{
                    return false
                }
             })
              newVariant.options.map((option) => {
                  let input = this.querySelector(`input[value='${option}']`);
                  if(input){
                      input.click() 
                  }
              })
            }
  
          }else{
             const newVariant = this.product.variants.find((v) => {
              if(v.options.includes(selected[0])){
                  return v
              }else{
                  return false
              }
           })
            newVariant.options.map((option) => {
                let input = this.querySelector(`input[value='${option}']`);
                if(input){
                    input.click() 
                }
            })
          }
  
  
        }
        this.hideInvalidOptions();
    }
    hideInvalidOptions(){
        const selected = this.selectedValues();
        let options2 = [];
        let options3 = [];
        if(selected.length > 1){
            let items = [selected[0], selected[1]];
            this.product.variants.map((variant) => {
                if(variant.option1 == selected[0]){
                    if(options2.indexOf(variant.option2) === -1){
                        options2.push(variant.option2);
                    } 
                    if(options3.indexOf(variant.option3) === -1 && items.every(elem => variant.options.includes(elem))){
                        options3.push(variant.option3);
                    } 
                }
                
            })
        }
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        selected.map((el, index) => {
            if(index == 0 ){
                return false; 
            }
            Array.from(fieldsets[index].querySelectorAll('input')).map((input) => {

                if(index == 1){
                    if(options2.indexOf(input.value) === -1){
                       // this.querySelector(`[data-name="${input.dataset.swatchTitle}"]`).style.display = "none";
                        this.querySelector(`.option2 [data-name="${input.dataset.swatchTitle}"]`).classList.add("disabled");
                    } else{
                        //this.querySelector(`[data-name="${input.dataset.swatchTitle}"]`).style.display = "block";
                        this.querySelector(`.option2 [data-name="${input.dataset.swatchTitle}"]`).classList.remove("disabled");
                    }
                }
                if(index == 2){
                    if(options3.indexOf(input.value) === -1){
                        //this.querySelector(`[data-name="${input.dataset.swatchTitle}"]`).style.display = "none";
                        this.querySelector(`.option3 [data-name="${input.dataset.swatchTitle}"]`).classList.add("disabled");
                    } else{
                        //this.querySelector(`[data-name="${input.dataset.swatchTitle}"]`).style.display = "block";
                        this.querySelector(`.option3 [data-name="${input.dataset.swatchTitle}"]`).classList.remove("disabled");
                    }
                }
            })
            
        })
       
    }
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
   
    setUnavailable() {
      const addButton = document.querySelector('[data-add-to-cart]');
      if (!addButton) return;
      addButton.textContent = window.variantStrings.unavailable;
      addButton.disabled = true;
    }
    selectedValues() {
        let selected = [];
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        selected = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
        return selected;
    }
  }
  
  customElements.define('product-variants', Variants);